module.exports = __webpack_public_path__ + "877b33447e5924f4f2468ffb96dbd452.svg";